import React from 'react';
import { Typography } from '@forgeglobal/design-framework';
import { SearchInputType } from '@tcs/client-portal-common/components/molecules/Search/types';
import { useStyles } from './style';

interface NoResultsPanelProps {
  type: SearchInputType;
}

const ADVICES: Record<SearchInputType, string> = {
  admin:
    'You can search by account holder’s name, account number, representative’s name, or representative code',
  representative: 'You can search by account holder’s name or account number',
};

const NoResultsPanel = ({ type }: NoResultsPanelProps) => {
  const classes = useStyles();

  return (
    <div className={classes.noResultWrapper}>
      <Typography variant="h6" className={classes.noResultTitle}>
        No results found
      </Typography>
      <ul className={classes.advices}>
        <li className={classes.adviceItem}>
          <Typography variant="body1" className={classes.advice}>
            Double check your spelling
          </Typography>
        </li>
        <li className={classes.adviceItem}>
          <Typography variant="body1" className={classes.advice}>
            Try entering fewer keywords
          </Typography>
        </li>
        <li className={classes.adviceItem}>
          <Typography variant="body1" className={classes.advice}>
            {ADVICES[type]}
          </Typography>
        </li>
      </ul>
    </div>
  );
};

export default NoResultsPanel;
